import { observable } from "mobx";
import { Type } from "class-transformer";
import AccountBalanceCheckRequestDetailAccessActionResponse from "./accountBalanceCheckRequestDetailAccessActionResponse";
import AccountBalanceCheckResultDownloadActionResponse from "./accountBalanceCheckResultDownloadActionResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class AccountBalanceCheckRequestPermittedActionsResponse {
  @observable
  @Type(() => AccountBalanceCheckRequestDetailAccessActionResponse)
  checkRequestDetailAccess!: AccountBalanceCheckRequestDetailAccessActionResponse;

  @observable
  @Type(() => AccountBalanceCheckResultDownloadActionResponse)
  checkResultDownload!: AccountBalanceCheckResultDownloadActionResponse;
}
